import React from 'react';
import {observer} from 'mobx-react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Translate from '../../../utils/Translate';
import Header from '../../commons/Header/Header';
import ProfileSummaryHeader from '../../commons/ProfileSummaryHeader/ProfileSummaryHeader';
import UpsertPersonalInfoContainer from './UpsertPersonalInfo/UpsertPersonalInfoContainer';
import UpsertPhoneInfoContainer from './UpsertPhoneInfo/UpsertPhoneInfoContainer';
import UpsertEmailInfoContainer from './UpsertEmailInfo/UpsertEmailInfoContainer';
import EditPasswordInfoContainer from './EditPasswordInfo/EditPasswordInfoContainer';
import DownloadPersonalInfo from './DownloadPersonalInfo/DownloadPersonalInfo';
import './PersonalInfoPage.css';
import Alert from '../../commons/Alert/Alert';
import DomUtils from '../../../utils/DomUtils';
import * as Pages from '../../../utils/Pages';
import Environment from '../../../utils/Environment';

@withRouter
@observer
class PersonalInfoPage extends React.Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
  }

  componentDidMount() {
    if (this.props.location.pathname.endsWith('/personal-info')) { DomUtils.scroll(this.node, { block: 'start' }); }
  }

  componentDidUpdate() {
    if (this.props.location.pathname.endsWith('/personal-info')) { DomUtils.scroll(this.node, { block: 'start' }); }
  }

  render() {
    return (
      <div ref={(node) => { this.node = node; }} >
        <div className="eva-3-dashboard-aftersale PersonalInfoPage -eva-3-tc-gray-1 -eva-3-bc-gray-4">
          <Header
            name={Translate.message('upsert-personal-info.title')}
            page={Pages.PERSONAL_INFO}
          />

          <div className="eva-3-container -eva-3-bc-gray-4 -p-0 -p-md-2 -pb-md-4 -pl-md-5 -pb-4 -pr-md-5 -pt-4">
            <div className="dashboard-aftersale-results-container eva-3-row -no-gutter">
              {
              this.props.profileStore.isMerging &&
              <div className="col -sm-12 -lg-8 -eva-3-mb-lg">
                <Alert type="warning" title={Translate.message('Estamos uniendo tus cuentas')}>
                  {Translate.message('Mientras se realiza el proceso, no podrás modificar los datos de tu perfil. Por favor, regresá más tarde.')}
                </Alert>
              </div>
            }
              <div className="col -sm-12 -lg-8 subnav-profile">
                <ProfileSummaryHeader
                  user={this.props.personalInfo}
                  disableEdit
                  small
                  clustersErrors={this.props.clustersErrors}
                  className="border-top-rounded -pt-3 -pb-3 -pl-2 -pr-2 -pl-md-4 -pr-md-4"
                  primaryEmail={this.props.personalInfo.emails.filter(email => email.isPrimary).pop()}
                />
              </div>
              <div className="col -sm-12 -lg-8 -mt-3">
                <UpsertPersonalInfoContainer
                  personalInfo={this.props.personalInfo}
                  loyalty={this.props.profileStore.loyaltyStore}
                  hasError={this.props.clustersErrors.personalInfo}
                  isMerging={this.props.profileStore.isMerging}
                />
              </div>

              <div className="col -sm-12 -lg-8 -mt-3">
                <UpsertPhoneInfoContainer
                  phones={this.props.personalInfo.phones}
                  hasError={this.props.clustersErrors.phones}
                  isMerging={this.props.profileStore.isMerging}
                />
              </div>

              <div className="col -sm-12 -lg-8 -mt-3">
                <UpsertEmailInfoContainer
                  emails={this.props.personalInfo.emails}
                  hasError={this.props.clustersErrors.emails || this.props.clustersErrors.personalInfo}
                  mergeStore={this.props.profileStore}
                  loyalty={this.props.profileStore.loyaltyStore}
                />
              </div>
              {
                this.props.personalInfo.isPasswordEditable && (
                  <div className="col -sm-12 -lg-8 -mt-3 ">
                    <EditPasswordInfoContainer
                      emails={this.props.personalInfo.emails}
                      hasError={this.props.clustersErrors.password}
                      isMerging={this.props.profileStore.isMerging}
                    />
                  </div>
              )
              }
              {
                Environment.appDomain.site === 'BR' &&
                  <div className="col -sm-12 -lg-8 -mt-3 ">
                    <DownloadPersonalInfo
                      isMerging={this.props.profileStore.isMerging}
                      hasError={this.props.clustersErrors.personalInfo}
                    />
                  </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PersonalInfoPage.defaultProps = {
  location: undefined,
};

PersonalInfoPage.propTypes = {
  personalInfo: PropTypes.shape().isRequired,
  clustersErrors: PropTypes.shape().isRequired,
  profileStore: PropTypes.shape().isRequired,
  location: PropTypes.shape(),
};


export default PersonalInfoPage;
